// extracted by css-extract-rspack-plugin
export default {"root":"dSb8Iu","muroIcon":"seFw4r","newIcon":"mTNDca"};